import { Observable } from "rxjs/Observable";
import * as actions from "./control-type.actions";
import { ControlType } from "./control-type.model";
import { VasBaseObjectStoreFacade } from "../base-object/vas-base-object-store.facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class ControlTypeStoreFacade extends VasBaseObjectStoreFacade<ControlType> {

    getAll(): Observable<Array<ControlType>> {
        return this.select(Qry.getInstance().controlType.items);
    }

    create(controlType: ControlType): void {
        this.dispatch(new actions.SubmitAction(controlType));
    }

    update(controlType: ControlType): void {
        this.dispatch(new actions.SubmitAction(controlType));
    }

    insert(controlType: ControlType): void {
        this.dispatch(new actions.SubmitAction(controlType, {persistable: true, restful: false}));
    }

    remove(controlType: ControlType, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(controlType, options));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control-type/control-type.store-facade.ts